<template>
  <div class="uk-height-1-1" style="margin-top: -80px">
    <div
      class="uk-cover-container"
      uk-height-viewport="offset-bottom: 10"
    >
      <img src="@/assets/images/rvdsb-3@2x.png" alt="" uk-cover>
      <div class="uk-overlay uk-overlay-primary uk-position-cover main-header-cover">
        <div class="uk-position-center">
          <div class="header-texts">
            <h1 class="header-styling-roos uk-margin-auto">Roos<br class="uk-hidden@m">Netjes</h1>
            <h2 class="uk-margin-remove-top voice-over-actrice-text">Voice-Over
              <br class="uk-hidden@m">& StemActrice</h2>
          </div>
          <div class="play-icon uk-align-center margin-bottom-17 ">
              <play-button-header
                class="uk-margin-auto uk-display-block uk-width-auto"
                :audio-file="require('@/assets/audio/Voicedemo_Compilatie.mp3')"
                audio-name="general-demo"/>
          </div>
          <div class="small-quote—-16pt uk-text-center uk-margin-medium-bottom">
            Luister naar mijn stemdemo
          </div>
          <div class="voice-over-button uk-display-block uk-margin-auto">
            <router-link :to="{ path: '/', hash: '#contactFormTwo' }"
                         class="voice-over-button-clickable-section uk-display-block">
              <a class="voice-over-button-text">voice-over aanvragen</a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayButtonHeader from '@/components/PlayButtonHeader.vue';

export default {
  name: 'MainHeader.vue',
  components: {
    PlayButtonHeader,
  },
};
</script>
